<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">添加信息</div>
    <Form :model="formData" :label-width="85"  :rules="formRules" ref="formData">
      <FormItem label="项目名称：" prop="projectFids" class="max64">
        <Select v-model="formData.projectFids" class="item-width" placeholder="请选择项目" multiple>
          <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
        </Select>
        <!-- <div class="ivu-select" >
          <div class="ivu-select-selection item-width">
            <Checkbox
              :indeterminate="true"
              :value="checkAll"
              @click.prevent.native="handleCheckAll">
                {{`全选（${products.length}）`}}
            </Checkbox>
            <i class="ivu-icon ivu-icon-ios-close ivu-select-arrow" style="display: none;"></i> <i class="ivu-icon ivu-icon-arrow-down-b ivu-select-arrow"></i>
          </div>
          <div class="ivu-select-dropdown item-width">
            <div class="check-box">
              <CheckboxGroup v-model="products" @on-change="checkAllProductsChange">
                <div class="item">
                  <Checkbox class="ivu-select-item" v-for="(pro,i) in projectList" :label="pro.value" :key="pro.value">{{pro.text}}</Checkbox>
                </div>
              </CheckboxGroup>
            </div>
          </div>
        </div> -->

      </FormItem>
      <FormItem label="电话：" prop="pzoPhone">
        <Input v-model="formData.pzoPhone" class="item-width" @on-blur="getZoInfo" ></Input>
      </FormItem>
      <FormItem label="" style="margin-top: -15px;" class="linh1">
        <Checkbox  v-model="isBeijing" class="error-color" >非北京归属地，请勾选</Checkbox>
      </FormItem>
      <FormItem label="系统号：" prop="pzoEmpCode" hidden>
        <Input v-model="formData.pzoEmpCode" class="item-width" ></Input>
      </FormItem>
      <FormItem label="员工姓名：" prop="pzoName">
        <Input :disabled="true" v-model="formData.pzoName" class="item-width" ></Input>
      </FormItem>
      <FormItem label="所属部门：" prop="pzoDepartment">
        <Input :disabled="true" v-model="formData.pzoDepartment" class="item-width" ></Input>
      </FormItem>
      <FormItem label="员工类型：" prop="empType">
        <Select v-model="formData.empType" class="item-width" placeholder="请选择员工类型" @on-change="changEmpType">
          <Option v-for="item in empTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="" prop="isProjectManager" v-if="formData.empType==1 ||formData.empType==3 ">
        <Checkbox  v-model="formData.isProjectManager">项目经理</Checkbox>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loading">
        <span v-if="!loading">保存</span>
        <span v-else>保存中...</span>
      </Button>
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">
  import { getEHRUseInfo, addZO } from 'api/managementCenter'

  export default {
    name:'addPermissionsModal',
    props:{
      n:{
        type:Number,
        default:0
      },
      projectList:{
        type:Array,
        default(){
          return []
        }
      },
      empTypeList:{
        type:Array,
        default(){
          return []
        }
      }
    },
    watch:{
      n(val){
        this.isBeijing=false
        this.$refs['formData'].resetFields();
        this.formData.isProjectManager = false
        this.show = true;
      }
    },
    data () {
      return {
        isBeijing:false,
        show:false,
        loading:false,
        checkAll:false,
        products:[],
        formData:{
          projectFids:[],
          pzoEmpCode:'',
          pzoName:'',
          pzoPhone:'',
          pzoDepartment:'',
          empType:'',
          isProjectManager:false
        },
        formRules:{
          projectFids:[{ required:true, type:'array', message:'请选择项目',triger:'blur' }],
          pzoEmpCode:[{ required:true, type:'string', message:'请输入系统号',triger:'blur' }],
          pzoName:[{ required:true, type:'string', message:'员工姓名为空',triger:'blur' }],
          pzoPhone:[{ required:true, type:'string', message:'员工手机号为空',triger:'blur' }],
          pzoDepartment:[{ required:true, type:'string', message:'所属部门为空',triger:'blur' }],
          empType:[{ required:true, type:'number', message:'请选择系员工类型', triger:'change' }],
        }
      };
    },

    methods:{
      changEmpType(val){
        if(val === 2){
          this.formData.isProjectManager = false
        }
      },
      handleCancel(){
        this.show = false
      },
      getZoInfo(){
        if(this.formData.pzoPhone){
          getEHRUseInfo(this.formData.pzoPhone.trim()).then( res => {
            if(res.data.name){
              this.formData.pzoName = res.data.name
              this.formData.pzoEmpCode = res.data.zoCode
              this.formData.pzoDepartment = res.data.dept
            } else {
              this.$Message.info('该手机号不存在！')
            }

          })
        }
      },
      save(){
        this.loading = true
        this.$refs[`formData`].validate(bool => {
          if(bool){
            let data = Object.assign({},this.formData)
            data['isBeijing']=this.isBeijing
            data.isProjectManager = data.isProjectManager ? 1 : 0
            addZO(data).then( res => {
              this.loading = false
              this.$Message.success('添加项目权限成功！')
              this.$emit('refresh')
              this.show = false
            }).catch( res => {
              this.loading = false
            })
          }else {
            this.loading = false
          }
        })
      }

    }
  }
</script>
<style scoped>
  .ivu-select-selection {
    line-height: 1.5;
    padding: 4px 7px;
  }
  .check-box {
    width:300px;
  }
  .ivu-checkbox-group-item{
    display: block;
  }
  .item {
    line-height: 1.5;
    padding: 4px 7px;

  }
  .item-width{
    width: 260px;
  }

</style>

